var _paused = false;
var tweensArray = [
    // 1
  {
    sceneId: '1',
    tween: function (isReverse) {
      var timeline = new TimelineMax({
        paused: _paused,
        //onStart: function () {
        //  console.log('tween0 start');
        //},
        onComplete: function () {
          TweenMax.fromTo('.slide-list-item1-copy',
              0.4,
              {
                top: '14.17312%',
                opacity: 0
              },
              {
                top: '16.17312%',
                opacity: 1
              });
          TweenMax.fromTo('.slide-list-item1-profile',
              0.4,
              {
                left: '78.85714%',
                opacity: 0
              },
              {
                left: '77.85714%',
                opacity: 1,
                delay: 0.2
              });
          TweenMax.fromTo('.slide-list-item1-btn-down',
              0.4,
              {
                top: '88.10478%',
                opacity: 0
              },
              {
                top: '89.10478%',
                opacity: 1,
                delay: 0.4
              });
        }
      });
      timeline.add([
        TweenMax.to('.slide-list-item1-copy', 0,
            {
              opacity: 0
            }),
        TweenMax.to('.slide-list-item1-profile', 0,
            {
              opacity: 0
            }),
        TweenMax.to('.slide-list-item1-btn-down', 0,
            {
              opacity: 0
            }),
        TweenMax.fromTo('.slide-list-item1', 0, {visibility: 'hidden'}, {
          top: 0,
          visibility: 'visible'
        }),
        TweenMax.fromTo('.slide-list-item1',
            0.8,
            //{top: (!isReverse) ? '100%' : '-100%' },
            {opacity: 0},
            {opacity: 1, ease: Cubic.easeIn}
        ),
        TweenMax.fromTo('.slide-list-item1',
            0.4,
            {scale: 1.1},
            {scale: 1, ease: Cubic.easeInOut, delay: 0.3, onComplete:function(){
                $item1_slider.length && $item1_slider.slick('slickPlay');
            }, onReverseComplete:function(){
                $item1_slider.length && $item1_slider.slick('slickPause');
            }}
        )
      ]);
      return timeline;
    }
  },

  // 2-1
  /*
  {
    sceneId: '2-1',
    tween: function (isReverse) {
      var timeline = new TimelineMax({
        paused: _paused
      });
      timeline.add([
        TweenMax.to('.slide-list-item1-copy',
            0.2,
            {opacity: 0}),
        TweenMax.to('.slide-list-item1-profile',
            0.2,
            {opacity: 0}),
        TweenMax.to('.slide-list-item1-btn-down',
            0.2,
            {opacity: 0}),
        TweenMax.fromTo('.slide-list-item1',
            0.4,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, onComplete:function(){
                $item1_slider.length && $item1_slider.slick('slickPause');
            }}
        ),
        TweenMax.fromTo('.slide-list-item2', 0, {visibility: 'hidden'}, {
          top: 0,
          visibility: 'visible'
        }),
        TweenMax.to('.slide-list-item2 .item1-1, .slide-list-item2 .item1-2', 0, {
          top: '0%'
        }),
        TweenMax.fromTo('.slide-list-item2',
            0.5,
            {top: '100%', opacity : 0.0},
            {top: '0%', ease: Cubic.easeInOut}
        ),
        TweenMax.fromTo('.slide-list-item2',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity: 1, ease: Cubic.easeInOut, delay: 0.4}
        )
      ]);
      return timeline;
    }
  },

  // 2-2
  {
    sceneId: '2-2',
    tween: function (isReverse) {
      var timeline = new TimelineMax({
        paused: _paused
      });
      timeline.add([
        TweenMax.fromTo('.slide-list-item2 .item1-1',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut}
        ),
        TweenMax.fromTo('.slide-list-item2 .item1-1',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.2}
        ),
        TweenMax.fromTo('.slide-list-item2 .item1-2',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut, delay: 0.2}
        ),
        TweenMax.fromTo('.slide-list-item2 .item1-2',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.3}
        ),
        TweenMax.fromTo('.slide-list-item2 .item2-1',
            0.5,
            {top: '100%'},
            {top: '0%', ease: Cubic.easeInOut, delay: 0.3}
        ),
        TweenMax.fromTo('.slide-list-item2 .item2-1',
            0.4,
            {scale: 0.9, opacity : 0.5},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.6}
        ),
        TweenMax.fromTo('.slide-list-item2 .item2-2',
            0.5,
            {top: '100%'},
            {top: '0%', ease: Cubic.easeInOut, delay: 0.5}
        ),
        TweenMax.fromTo('.slide-list-item2 .item2-2',
            0.4,
            {scale: 0.9, opacity : 0.5},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.8}
        )
      ]);
      return timeline;
    }
  },

  // 2-3
  {
    sceneId: '2-3',
    tween: function (isReverse) {
      var timeline = new TimelineMax({
        paused: _paused
      });
      timeline.add([
        TweenMax.fromTo('.slide-list-item2 .item2-1',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut }
        ),
        TweenMax.fromTo('.slide-list-item2 .item2-1',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.2}
        ),
        TweenMax.fromTo('.slide-list-item2 .item2-2',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut, delay: 0.2 }
        ),
        TweenMax.fromTo('.slide-list-item2 .item2-2',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.3 }
        ),

        TweenMax.fromTo('.slide-list-item2 .item3-1',
            0.5,
            {top: '100%', opacity : 0.5},
            {top: '0%', ease: Cubic.easeInOut, delay: 0.3}
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-1',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.6}
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-2',
            0.5,
            {top: '100%', opacity : 0.5},
            {top: '0%', ease: Cubic.easeInOut, delay: 0.5}
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-2',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.7}
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-3',
            0.5,
            {top: '100%', opacity : 0.5},
            {top: '0%', ease: Cubic.easeInOut, delay: 0.7}
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-3',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.9}
        )
      ]);
      return timeline;
    }
  },
  */

/*
  // 2-4
  {
    sceneId: '2-4',
    tween: function (isReverse) {
      var timeline = new TimelineMax({
        paused: _paused
      });
      timeline.add([
        TweenMax.fromTo('.slide-list-item2 .item3-1',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut }
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-1',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.2 }
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-2',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut, delay: 0.2 }
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-2',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.3 }
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-3',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut, delay: 0.4 }
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-3',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.5 }
        ),

        TweenMax.fromTo('.slide-list-item2 .item4-1',
            0.5,
            {top: '100%', opacity : 0.5},
            {top: '0%', ease: Cubic.easeInOut, delay: 0.3}
        ),
        TweenMax.fromTo('.slide-list-item2 .item4-1',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.6}
        ),
        TweenMax.fromTo('.slide-list-item2 .item4-2',
            0.5,
            {top: '100%', opacity : 0.5},
            {top: '0%', ease: Cubic.easeInOut, delay: 0.5}
        ),
        TweenMax.fromTo('.slide-list-item2 .item4-2',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.6}
        ),
        TweenMax.fromTo('.slide-list-item2 .item4-3',
            0.5,
            {top: '100%', opacity : 0.5},
            {top: '0%', ease: Cubic.easeInOut, delay: 0.7}
        ),
        TweenMax.fromTo('.slide-list-item2 .item4-3',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.9}
        )
      ]);
      return timeline;
    }
  },
*/

  // 3-1
  {
    sceneId: '3-1',
    tween: function (isReverse) {
      var timeline = new TimelineMax({
        paused: _paused
      });
      timeline.add([
        /*
        TweenMax.fromTo('.slide-list-item2 .item3-1',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut }
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-1',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.2 }
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-2',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut, delay: 0.2 }
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-2',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.3 }
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-3',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut, delay: 0.4 }
        ),
        TweenMax.fromTo('.slide-list-item2 .item3-3',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.5 }
        ),
        */
        TweenMax.to('.slide-list-item1-copy',
            0.2,
            {opacity: 0}),
        TweenMax.to('.slide-list-item1-profile',
            0.2,
            {opacity: 0}),
        TweenMax.to('.slide-list-item1-btn-down',
            0.2,
            {opacity: 0}),
        TweenMax.fromTo('.slide-list-item1',
            0.4,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, onComplete:function(){
                $item1_slider.length && $item1_slider.slick('slickPause');
            }}
        ),

        TweenMax.fromTo('.slide-list-item3', 0, {visibility: 'hidden'}, {
          top: 0,
          visibility: 'visible'
        }),
        TweenMax.to('.slide-list-item3 .item1-1, .slide-list-item3 .item1-2, .slide-list-item3 .item1-3', 0, {
          top: '0%'
        }),

        TweenMax.fromTo('.slide-list-item3',
            0.5,
            {top: '100%', opacity : 0.0},
            {top: '0%', ease: Cubic.easeInOut, delay: 0.0}
        ),
        TweenMax.fromTo('.slide-list-item3',
            0.6,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.4}
        )
      ]);
      return timeline;
    }
  },

  // 3-2
  {
    sceneId: '3-2',
    tween: function (isReverse) {
      var timeline = new TimelineMax({
        paused: _paused
      });
      timeline.add([
        TweenMax.fromTo('.slide-list-item3 .item1-1',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut }
        ),
        TweenMax.fromTo('.slide-list-item3 .item1-1',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.2 }
        ),
        TweenMax.fromTo('.slide-list-item3 .item1-2',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut, delay: 0.2 }
        ),
        TweenMax.fromTo('.slide-list-item3 .item1-2',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.3 }
        ),
        TweenMax.fromTo('.slide-list-item3 .item1-3',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut, delay: 0.3 }
        ),
        TweenMax.fromTo('.slide-list-item3 .item1-3',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.4 }
        ),

        TweenMax.fromTo('.slide-list-item3 .item2-1',
            0.5,
            {top: '100%', opacity : 0.5},
            {top: '0%', ease: Cubic.easeInOut, delay: 0.3}
        ),
        TweenMax.fromTo('.slide-list-item3 .item2-1',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.6}
        ),
        TweenMax.fromTo('.slide-list-item3 .item2-2',
            0.5,
            {top: '100%', opacity : 0.5},
            {top: '0%', ease: Cubic.easeInOut, delay: 0.5}
        ),
        TweenMax.fromTo('.slide-list-item3 .item2-2',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.6}
        ),
        TweenMax.fromTo('.slide-list-item3 .item2-3',
            0.5,
            {top: '100%', opacity : 0.5},
            {top: '72.343%', ease: Cubic.easeInOut, delay: 0.7}
        ),
        TweenMax.fromTo('.slide-list-item3 .item2-3',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.9}
        )
      ]);
      return timeline;
    }
  },

  // 3-3
  {
    sceneId: '3-3',
    tween: function (isReverse) {
      var timeline = new TimelineMax({
        paused: _paused
      });
      timeline.add([
        TweenMax.fromTo('.slide-list-item3 .item2-1',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut }
        ),
        TweenMax.fromTo('.slide-list-item3 .item2-1',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.2 }
        ),
        TweenMax.fromTo('.slide-list-item3 .item2-2',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut, delay: 0.2 }
        ),
        TweenMax.fromTo('.slide-list-item3 .item2-2',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.3 }
        ),
        TweenMax.fromTo('.slide-list-item3 .item2-3',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut, delay: 0.3 }
        ),
        TweenMax.fromTo('.slide-list-item3 .item2-3',
            0.5,
            {top: '72.343%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.4 }
        ),

        TweenMax.fromTo('.slide-list-item3 .item3-1',
            0.5,
            {top: '100%', opacity : 0.5},
            {top: '0%', ease: Cubic.easeInOut, delay: 0.4}
        ),
        TweenMax.fromTo('.slide-list-item3 .item3-1',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.6}
        ),
        TweenMax.fromTo('.slide-list-item3 .item3-2',
            0.5,
            {top: '100%', opacity : 0.5},
            {top: '0%', ease: Cubic.easeInOut, delay: 0.5}
        ),
        TweenMax.fromTo('.slide-list-item3 .item3-2',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.7}
        ),
        TweenMax.fromTo('.slide-list-item3 .item3-3',
            0.5,
            {top: '100%', opacity : 0.5},
            {top: (425 / 828 * 100) + '%', ease: Cubic.easeInOut, delay: 0.6}
        ),
        TweenMax.fromTo('.slide-list-item3 .item3-3',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.8}
        ),
        TweenMax.fromTo('.slide-list-item3 .item3-4',
            0.5,
            {top: '100%', opacity : 0.5},
            {top: (425 / 828 * 100) + '%', ease: Cubic.easeInOut, delay: 0.7}
        ),
        TweenMax.fromTo('.slide-list-item3 .item3-4',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.9}
        )
      ]);
      return timeline;
    }
  },

  // 4-1
  {
    sceneId: '4-1',
    tween: function (isReverse) {
      var timeline = new TimelineMax({
        paused: _paused
      });
      timeline.add([
        TweenMax.fromTo('.slide-list-item3 .item3-1',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut }
        ),
        TweenMax.fromTo('.slide-list-item3 .item3-1',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.2 }
        ),
        TweenMax.fromTo('.slide-list-item3 .item3-2',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut, delay: 0.2 }
        ),
        TweenMax.fromTo('.slide-list-item3 .item3-2',
            0.5,
            {top: '0%'},
            {top: '-100%', ease: Cubic.easeInOut, delay: 0.3 }
        ),
        TweenMax.fromTo('.slide-list-item3 .item3-3',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut, delay: 0.2 }
        ),
        TweenMax.fromTo('.slide-list-item3 .item3-3',
            0.5,
            {top: (425 / 828 * 100) + '%'},
            {top: '-=100%', ease: Cubic.easeInOut, delay: 0.3 }
        ),
        TweenMax.fromTo('.slide-list-item3 .item3-4',
            0.4,
            {scale: 1, opacity : 1},
            {scale: 0.9, opacity : 0.5, ease: Cubic.easeInOut, delay: 0.3 }
        ),
        TweenMax.fromTo('.slide-list-item3 .item3-4',
            0.5,
            {top: (425 / 828 * 100) + '%'},
            {top: '-=100%', ease: Cubic.easeInOut, delay: 0.4 }
        ),

        TweenMax.fromTo('.slide-list-item4', 0, {visibility: 'hidden'}, {
          top: 0,
          visibility: 'visible'
        }),

        TweenMax.fromTo('.slide-list-item4 .item1-1',
            0.5,
            {top: '100%', opacity : 0.0},
            {top: '0%', ease: Cubic.easeInOut, delay: 0.5}
        ),
        TweenMax.fromTo('.slide-list-item4 .item1-1',
            0.4,
            {scale: 0.9},
            {scale: 1, opacity : 1, ease: Cubic.easeInOut, delay: 0.9}
        )
      ]);
      return timeline;
    }
  }


];
